import {Component, inject, ChangeDetectionStrategy} from "@angular/core"
import {RouterOutlet} from "@angular/router"
import {CheckboxesFilterComponent, SearchFilterComponent} from "@common/components/filters"
import {ItemFiltersComponent} from "@common/components/item"
import {OrganizationsService} from "@common/services/organizations/organizations.service"
import {HdrisGridComponent} from "@platform/components/hdris/hdris-grid/hdris-grid.component"
import {SidebarLayoutComponent} from "@platform/components/layouts/sidebar-layout/sidebar-layout.component"
import {CreateItemComponent} from "@common/components/base/create-item.component"
import {AddHdriDialogComponent} from "@platform/components/hdris/add-hdri-dialog/add-hdri-dialog.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-hdris-page",
    imports: [ItemFiltersComponent, RouterOutlet, SearchFilterComponent, CheckboxesFilterComponent, SidebarLayoutComponent, HdrisGridComponent],
    templateUrl: "./hdris-page.component.html",
    styleUrl: "./hdris-page.component.scss",
})
export class HdrisPageComponent extends CreateItemComponent<AddHdriDialogComponent> {
    readonly organizations = inject(OrganizationsService)

    protected openCreateDialog() {
        const dialogRef = this.dialog.open(AddHdriDialogComponent, {
            data: {},
        })
        this.setDialogRef(dialogRef)
    }
}
